import React from "react";
import propTypes from "prop-types";

import frame from "../img/recorder-frame.svg";
import "../styles/Webcam.css";

const Webcam = ({ srcObjectRef }) => (
  <div className="fixed">
    <video ref={srcObjectRef} className="screen-cam" autoPlay muted />
    <img src={frame} className="ghost" alt="frame" />
  </div>
);

Webcam.propTypes = {
  srcObjectRef: propTypes.object
};

export default Webcam;
